<h1 md-dialog-title class="d-flex justify-content-center">{{data.title}}</h1>
<BR>
<div md-dialog-content class="d-flex justify-content-center">{{data.message}}</div>
<BR><BR>
<div md-dialog-actions class="d-flex justify-content-center">
  <button md-button style="color: #fff;background-color: #153961;" (click)="this.actionOk()">OK</button>
</div>